<template>
  <div class="flex flex-row items-center  p-5">
    <img class="flex-none mr-1" src="@/assets/images/logo/logo_FAstation.svg" />
    <!-- <img class="flex-none mr-1" src="@/assets/images/elements/hod.png">  -->

    <div class="flex-grow px-5 w-full">
      <div class="flex flex-row items-center">
        <hr class="flex-grow w-full line-blue" />
        <div class="flex-none square-blue"></div>
      </div>
    </div>

    <div class="flex-none ml-1 title">{{ Titlepage }}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      activePage: "general/activePage"
    }),
    Titlepage() {
      switch (this.activePage.slug) {
        case "curriculum":
          return (this.title = "จัดการคอร์สเรียน");
        case "curriculumtype":
          return (this.title = "จัดการคอร์สเรียน");
        case "lecturer":
          return (this.title = "จัดการรายชื่อผู้สอน");
        case "banner":
          return (this.title = "จัดการ Banner");
        default:
          return (this.title = this.activePage.name);
      }
    }
  },
  data() {
    return {
      title: null
    };
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-family: "Kanit", sans-serif;
  font-size: 18px;
  color: rgba(117, 149, 204, 1);
}
hr.line-blue {
  border-top: 3px solid #7595cc;
}
.square-blue {
  width: 12px;
  height: 12px;
  transform: rotate(45deg);
  background-color: #7595cc;
}
</style>
